export default "__VITE_ASSET__DsqTK0$G__"